// extracted by mini-css-extract-plugin
module.exports = {"Container":"User_Container__2bJVO","Form":"User_Form__2q72Z"};